export const formatDateTimeService = (dateInput: Date): string => {
    const date = new Date(dateInput.toString());
    const day = date?.getDate().toString().padStart(2, '0');;
    const month = (date?.getMonth() + 1).toString().padStart(2, '0');
    const year = date?.getFullYear().toString();
    const hours = date?.getHours().toString().padStart(2, '0');
    const minutes = date?.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`; 
}